import { Component, Input } from '@angular/core';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'entity-monitoring-client',
  templateUrl: './entity-monitoring-client.component.html'
})

export class EntityMonitoringClientComponent {
  @Input() entityIdDetails: EntityIdDetails;
  entityType = 'Client';

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/entitymonitoringclient/entity-monitoring-client.component.ts